import React, { useEffect, useState } from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate, useParams } from "react-router-dom";
import Initials from "../../components/Initials/Initials";
import { FiPhoneCall } from "react-icons/fi";
import SubscriptionCard from "../../components/Cards/SubscriptionCard";
import DishImg from "../../assets/images/imgLibrary/01.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubscribedMealList,
  onHoldPlan,
  onCancelPlan,
  onRenewPlan,
  onResumePlan,
} from "../../redux/thunks/deiverAnorderThunk";
import { getCustomerRecords } from "../../redux/thunks/customerRecordThunk";
import CancelSubscriptionModal from "../../components/Modals/CancelSubscriptionModal";
import toast from "react-hot-toast";
import HoldSubscriptionModal from "../../components/Modals/HoldSubscriptionModal";
import RenewSubscriptionModal from "../../components/Modals/RenewSubscriptionModal";
import SubsCardShimmer from "../../components/Preloader/SubsCardShimmer";
import Pagination from "../../components/Pagination";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId, encryptId } from "../../utils/urlCrypto";
import ResumeSubscriptionModal from "../../components/Modals/ResumeSubscriptionModal";
import { UserX } from "lucide-react";

const SubscribeView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subscribedMeals, pagination, isPlanLoading } = useSelector(
    (state) => state.planSlice,
  );

  const { customer_id } = useParams();
  const customerId = decryptId(customer_id);
  const [totalAm, setTotalAm] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [paymentRc, setPaymentRc] = useState(null);
  const [amountDu, setAmountDu] = useState(null);
  const [totalTC, setTotalTC] = useState(null);
  const [customersAdd, setCustomersAdd] = useState("");
  const [initials, setInitials] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [code, setCode] = useState(1);
  const [openCancel, setOpenCancel] = useState(false);
  const [openHold, setOpenHold] = useState(false);
  const [openRenew, setOpenRenew] = useState(false);
  const [Currency, setCurrency] = useState("");
  const [OpenResume, setOpenResume] = useState(false);
  const [selectedMealPlanId, setSelectedMealPlanId] = useState(null);
  const getVariantFromPlan = (plan) => {
    if (plan.status === "completed" || plan.meals_left === 0) {
      return "completed";
    }

    switch (plan.status) {
      case "upcoming":
        return "upcoming";
      case "cancelled":
        return "canceled";
      case "inactive":
        return "inactive";
      case "hold":
        return "hold";
      case "active":
      default:
        return "active";
    }
  };

  const fetchCustomerDetail = () => {
    const payload = { service_provider_customer_id: customerId };
    dispatch(getCustomerRecords(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of detail is :", res.data);
        setCustomerName(res.data?.customer_name);
        setCustomerNumber(res.data?.contact_no);

        const address1 = res.data?.default_address?.address_1 || "";

        setCustomersAdd(address1);

        const totalAmount = res.data?.total_amount;
        setTotalAm(totalAmount);

        const paymentRecieved = res.data?.payment_received;
        setPaymentRc(paymentRecieved);

        const amountDue = res.data?.amount_due;
        setAmountDu(amountDue);

        const totaltiffin = res.data?.total_tiffins_consumed;
        setTotalTC(totaltiffin);

        const getInitial = res.data?.initials;
        setInitials(getInitial);

        const getCOde = res.data?.country_code;
        setCode(getCOde);

        const getCurrency = res.data?.currency_symbol;
        setCurrency(getCurrency);
      });
  };

  useEffect(() => {
    fetchCustomerDetail();
  }, [customerId]);

  useEffect(() => {
    // console.log("the customer id is :", customerId);
    dispatch(
      getSubscribedMealList({
        service_provider_customer_id: customerId,
        page: currentPage,
      }),
    )
      .unwrap()
      .then((res) => {
        // console.log("The res of meal list get is :", res);
      })
      .catch((err) => {
        console.error("Error while fetching meal list:", err);
      });
  }, [dispatch, customerId, currentPage]);

  const handleGoBack = () => {
    navigate(`/customers-detail/${encryptId(customerId)}`);
  };

  const onEditHandle = (mealPlanId) => {
    navigate(`/edit-subscription/${encryptId(mealPlanId)}`, {
      state: {
        customerId,
      },
    });
  };

  const onCancelHandle = (mealPlanId) => {
    setSelectedMealPlanId(mealPlanId);
    setOpenCancel(true);
  };
  const onHoldHandle = (mealPlanId) => {
    // console.log("Hold clicked for meal plan id:", mealPlanId);
    setSelectedMealPlanId(mealPlanId);
    setOpenHold(true);
  };

  const handleCardClick = (mealPlanId) => {
    navigate(`/subscription/subscription-detail/${encryptId(mealPlanId)}`, {
      state: {
        customerId,
      },
    });
  };

  const onHoldConfirm = async () => {
    if (!selectedMealPlanId) return;

    const payload = {
      sp_customer_meal_plan_id: selectedMealPlanId,
    };

    // console.log(
    //   "The sp customer meal plan id on hold is :",
    //   selectedMealPlanId,
    // );
    try {
      setOpenHold(false);
      const res = await dispatch(onHoldPlan(payload)).unwrap();

      if (!res.success) {
        toast.error(res.message);
        return;
      }

      toast.success(res.message);

      dispatch(
        getSubscribedMealList({ service_provider_customer_id: customerId }),
      );
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const onResumeHandle = async (mealPlanId) => {
    setSelectedMealPlanId(mealPlanId);
    setOpenResume(true);
  };

  const onResumeConfirm = async () => {
    if (!selectedMealPlanId) return;
    const payload = {
      sp_customer_meal_plan_id: selectedMealPlanId,
    };
    // console.log("The sp customer meal id is on resume :", mealPlanId);

    try {
      setOpenResume(false);
      const res = await dispatch(onResumePlan(payload)).unwrap();
      if (!res.success) {
        toast.error(res.message);
        return;
      }

      toast.success(res.message);

      dispatch(
        getSubscribedMealList({ service_provider_customer_id: customerId }),
      );
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const onRenewHandle = (mealPlanId) => {
    setSelectedMealPlanId(mealPlanId);
    setOpenRenew(true);
  };

  const onRenewConfirm = async () => {
    if (!selectedMealPlanId) return;

    const payload = {
      sp_customer_meal_plan_id: selectedMealPlanId,
    };

    try {
      setOpenRenew(false);
      const res = await dispatch(onRenewPlan(payload)).unwrap();
      if (!res.success) {
        toast.error(res.message);
        return;
      }

      toast.success(res.message);

      dispatch(
        getSubscribedMealList({ service_provider_customer_id: customerId }),
      );
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const formatDateTime12 = (dateTime) => {
    if (!dateTime) return "";
    const date = new Date(dateTime.replace(" ", "T"));
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour12: true,
    });
  };

  return (
    <>
      <section className="space-y-6 max-w-7xl mx-auto relative max-h-screen">
        <DecorativeSquares />
        <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
          <button
            onClick={handleGoBack}
            className="flex items-center p-2 rounded-full hover:bg-gray-100"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="mx-auto text-2xl font-semibold text-gray-900">
            Subscription
          </h1>
        </div>
        <div className="px-4 mt-8 space-y-4">
          <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-3 md:p-6 shadow-sm">
            <div className="flex justify-between">
              <div className="flex items-center gap-4">
                {/* Avatar */}
                <Initials initial={initials} />
                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {customerName}
                  </h2>

                  <p className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                    <FiPhoneCall size={10} />+{code} {customerNumber}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-b border-gray-100 mt-8"></div>
            <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 place-items-center gap-4">
              {isPlanLoading ? (
                Array.from({ length: 3 }).map((_, i) => (
                  <SubsCardShimmer key={i} />
                ))
              ) : subscribedMeals.length === 0 ? (
                <div className="flex flex-col justify-center items-center">
                  <UserX size={35} className="text-gray-400"/>
                  <p className="text-center col-span-full text-gray-400">
                    No subscriptions found
                  </p>
                </div>
              ) : (
                subscribedMeals.map((meal) => (
                  <SubscriptionCard
                    key={meal.sp_customer_meal_plan_id}
                    variant={getVariantFromPlan(meal)}
                    currencySymbol={Currency}
                    status={meal.status}
                    image={meal.meal_image}
                    title={meal.meal_name}
                    price={meal.price_per_meal}
                    startDate={formatDateTime12(meal.start_date)}
                    quantity={meal.meal_quantity}
                    mealType={meal.meal_timing}
                    deliveryType={
                      meal.delivery_type === "delivery"
                        ? "Home Delivery"
                        : "Pick up"
                    }
                    mealsConsumed={meal.meals_consumed}
                    leftmeal={`${meal.meals_left} Meals Left`}
                    can_cancel={meal.can_cancel}
                    can_hold={meal.can_hold}
                    can_renew={meal.can_renew}
                    can_resume={meal.can_resume}
                    isEditClicked={() =>
                      onEditHandle(meal.sp_customer_meal_plan_id)
                    }
                    startUpMessage={`Renew Starting After ${meal.meals_left} meals`}
                    onCancelClick={() =>
                      onCancelHandle(meal.sp_customer_meal_plan_id)
                    }
                    onRenewClick={() =>
                      onRenewHandle(meal.sp_customer_meal_plan_id)
                    }
                    onResumeClick={() =>
                      onResumeHandle(meal.sp_customer_meal_plan_id)
                    }
                    onHoldClick={() =>
                      onHoldHandle(meal.sp_customer_meal_plan_id)
                    }
                    onCardClick={() =>
                      handleCardClick(meal.sp_customer_meal_plan_id)
                    }
                  />
                ))
              )}
            </div>
          </div>
          {pagination.total_pages > 1 && (
            <div className="mt-6">
              <Pagination
                current={currentPage}
                total={pagination.total_pages}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
        </div>
      </section>

      <CancelSubscriptionModal
        open={openCancel}
        onClose={() => setOpenCancel(false)}
        onConfirm={async () => {
          if (!selectedMealPlanId) return;

          const payload = {
            sp_customer_meal_plan_id: selectedMealPlanId,
            cancelled_by: "customer",
          };

          try {
            const res = await dispatch(onCancelPlan(payload)).unwrap();

            if (!res.success) {
              toast.error(res.message);
              return;
            }

            toast.success(res.message);
            setOpenCancel(false);

            dispatch(
              getSubscribedMealList({
                service_provider_customer_id: customerId,
                page: currentPage,
              }),
            );
          } catch (err) {
            toast.error("Something went wrong");
          }
        }}
      />

      <HoldSubscriptionModal
        open={openHold}
        onClose={() => setOpenHold(false)}
        onConfirm={onHoldConfirm}
      />

      <ResumeSubscriptionModal
        open={OpenResume}
        onClose={() => setOpenResume(false)}
        onConfirm={onResumeConfirm}
      />

      <RenewSubscriptionModal
        open={openRenew}
        onClose={() => setOpenRenew(false)}
        onConfirm={onRenewConfirm}
      />
    </>
  );
};

export default SubscribeView;
